import styled from "styled-components";

export const MeteringSegment = styled.div`
    transition: width 250ms ease;
    height: inherit;
    background-color: ${({ variant }) =>
        variant === "secondary" ? "#C53090" : variant === "error" ? "#d82829" : "#0090D1"};
    width: ${({ percent }) => `${percent}%`};
`;
